import { createAsyncAction, request } from "../lib/utils";
import { SubmissionError } from "redux-form";

import routes from "../routes";

import cookie from "react-cookies";
import axios from "axios";

import { get as getAgency } from "../settings/actions";

export const logout = token => async (dispatch, getState) => {
  dispatch(removeAuthCookies());
  window.location.href = routes.signIn;
};

export const signInAction = createAsyncAction("signIn");
export const signIn = data => async (dispatch, getState) => {
  const rs = await request(
    "post",
    "/v1/auth/get-token",
    {
      data
    },
    {
      action: signInAction,
      dispatch,
      errorHandler: ({ response }) => {
        if (response.status === 401) {
          throw new SubmissionError({ _error: "Niepoprawny email lub hasło" });
        }
      }
    }
  );
  dispatch(setAuthHeaders(rs.data));
  dispatch(setAuthCookies(rs.data));

  const uid = JSON.parse(atob(rs.data.token.split(".")[1])).uid;
  dispatch(getCurrentUser(uid));
  return rs;
};

export const signUpAction = createAsyncAction("signUp");
export const signUp = data => async (dispatch, getState) => {
  const rs = await request(
    "post",
    "/v1/users",
    {
      data
    },
    {
      action: signUpAction,
      dispatch,
      errorHandler: ({ response }) => {
        if (response.status === 422) {
          throw new SubmissionError({ email: "Email jest już zajęty" });
        }
      }
    }
  );

  const d = { username: data.email, password: data.password };
  dispatch(signIn(d));
  return rs;
};

export const resetPasswordAction = createAsyncAction("resetPassword");
export const resetPassword = data => async (dispatch, getState) => {
  return request(
    "put",
    "/v1/user/reset-password",
    {
      data
    },
    {
      action: resetPasswordAction,
      dispatch
    }
  );
};

export const setPasswordAction = createAsyncAction("setPassword");
export const setPassword = data => async (dispatch, getState) => {
  return request(
    "patch",
    "/v1/user/set-password",
    {
      data
    },
    {
      action: setPasswordAction,
      dispatch,
      errorHandler: ({ response }) => {
        if (response.status === 422) {
          throw new SubmissionError();
        }
      }
    }
  );
};

export const refreshTokenAction = createAsyncAction("refreshToken");
export const refreshToken = token => async (dispatch, getState) => {
  const rs = await request("get", "/v1/auth/refresh-token", null, {
    action: refreshTokenAction,
    dispatch,
    errorHandler: ({ response }) => {
      if (response.status === 401) {
        dispatch(logout());
      }
    }
  });

  dispatch(setAuthCookies(rs.data));
  dispatch(setAuthHeaders(rs.data));
  return rs;
};

export const getCurrentUserAction = createAsyncAction("getCurrentUser");
export const getCurrentUser = uid => async (dispatch, getState) => {
  const rs = await request("get", `/v1/users/${uid}`, null, {
    action: getCurrentUserAction,
    dispatch
  });
  if (rs) {
    dispatch(getAgency(rs.data.agencyUID));
  }
  return rs;
};

export const removeAuthCookies = data => async (dispatch, getState) => {
  cookie.remove("jwt-token", { path: "/" });
};
export const setAuthCookies = data => async (dispatch, getState) => {
  cookie.save("jwt-token", data, { path: "/" });
};
export const setAuthHeaders = data => async (dispatch, getState) => {
  axios.defaults.headers.common["Authorization"] = `Bearer ${data.token}`;
};



// WEBPACK FOOTER //
// ./src/auth/actions.js